jQuery(document).ready(function() {
  function updateTags() {
    var tags = [];
    if (jQuery('#newsletteroptionhenley').is(':checked')) {
      tags.push(jQuery('#newsletteroptionhenley').val());
    }
    if (jQuery('#newsletteroptionmarlow').is(':checked')) {
      tags.push(jQuery('#newsletteroptionmarlow').val());
    }
    if (jQuery('#newsletteroptionallpacks').is(':checked')) {
      tags.push(jQuery('#newsletteroptionallpacks').val());
    }    
    jQuery('#tagstosend').val(tags.join(','));
  }

  jQuery('#newsletteroptionhenley, #newsletteroptionmarlow, #newsletteroptionallpacks').change(function() {
    updateTags();
  });

  // Initial update in case checkboxes are pre-checked
  updateTags();
});


jQuery(".filter-marlow").click(function(){
  jQuery(".supplier-list").toggleClass("marlow");
  jQuery(".supplier-list").removeClass("henley");
  jQuery(".filter-marlow").toggleClass("active");
  jQuery(".filter-henley").removeClass("active");
  jQuery(".filter-clear").removeClass("active");
});
jQuery(".filter-henley").click(function(){
  jQuery(".supplier-list").toggleClass("henley");
  jQuery(".supplier-list").removeClass("marlow");
  jQuery(".filter-henley").toggleClass("active");
  jQuery(".filter-marlow").removeClass("active");
  jQuery(".filter-clear").removeClass("active");
});
jQuery(".filter-clear").click(function(){
  jQuery(".filter-clear").addClass("active");
  jQuery(".supplier-list").removeClass("marlow");
  jQuery(".supplier-list").removeClass("henley");
  jQuery(".filter-henley").removeClass("active");
  jQuery(".filter-marlow").removeClass("active");
});





/*
document.querySelector('button.add-to-cart').addEventListener('click', function(event) {
console.log('add to cart 1');
});*/

/*
window.addtobasket = false;

document.addEventListener("submit", function(event) {
//var addtobasket = false;
//card IDs 9843445891371, 9843446579499
var addedtobasket = jQuery(event.target).find('input[name=product-id]').val();
//console.log(addedtobasket);

if (addedtobasket == 9843445891371) {
  console.log('add to 1');
  $.ajaxSetup({
    async: false
});
  jQuery.getJSON('/cart.js', function(cart) {
    var cartitemamount = cart.items.length;
if(cartitemamount > 0) {
  console.log('add to 2');


    cart.items.forEach(function(item) {
      if (item.product_id != 9843445891371) {
        console.log('add to 3');

        window.addtobasket = true;
      }
      //console.log('Product ID:', item.product_id);
    });

  }
  });
}
//console.log(addtobasket);

if(addtobasket == true) {
  alert('You can only add one of these to your basket');

  

}



});
*/


/*
var rewind = jQuery('#henley-rewind-festival image-banner picture');
var rewindsize = parseInt(rewind.css('background-size').split(',')[0].replace('px'));
var rewindposition1 = parseInt(rewind.css('background-position').split(',')[0].split(' ')[0].replace('%'));
var rewindposition2 = parseInt(rewind.css('background-position').split(',')[0].split(' ')[1].replace('%'));


jQuery(window).scroll(function (event) {
    var scrollvar = $(window).scrollTop();
    scrollvar = Math.floor(scrollvar);
///console.log(rewindposition2);
//console.log(scrollvar);
    var scrollsize = rewindsize - (scrollvar * 3.4);
    var scrollposition2 = rewindposition2 + (scrollvar * 0.07);
    var scrollposition1 = rewindposition1 - (scrollvar * 0.9);
    console.log(scrollvar * 0.1);
    //rewindposition2 = rewindposition2 - scrollvar;
    //var scrollposition = rewindposition1+'% '+rewindposition2+'%';
    //console.log(scrollposition);
    //console.log(scrollposition);

    jQuery('#henley-rewind-festival image-banner picture').css('background-size',scrollsize+'px');
    jQuery('#henley-rewind-festival image-banner picture').css('background-position',scrollposition1+'% '+scrollposition2+'%' );
   // console.log("scroll: " + scrollvar);
});




var rewind = jQuery('#henley-rewind-festival image-banner picture');
var count = 100;
var position1 = 18;
//var position1 = parseInt(rewind.css('background-position').split(',')[0].split(' ')[1].replace('%'));
jQuery(function(){
        window.setInterval(function() {

            count = count - 0.2;
            position1 = position1 + 0.09;
                 
if (count < -15) {
    count = 103;
    position1 = 18;
}
console.log(position1);
jQuery('#henley-rewind-festival image-banner picture').css('background-position',count+'% '+position1+'%' );

        }, 100);

});









( function( $ ) {

    const tilt = $('#belowbanner .image1 img').tilt();


    // Reset instance
   // tilt.tilt.reset.call(tilt);

    tilt.tilt({
    maxTilt: 12,
    easing: "cubic-bezier(.03,.98,.52,.99)",
    speed: 1200,
    glare: false,
    maxGlare: 0.2,
  });


  //tilt.on('tilt.mouseLeave', tilt.tilt.reset.call(tilt)); // parameters: event
  
}( jQuery ) );
*/


